import type React from 'react';

import Button from '@polyai/ui/components/atoms/Button';
import { ArrowLeftIcon } from '@polyai/ui/components/atoms/Icons';

import { BackgroundImage, Logo } from './components';

interface OTFromScreenProps {
  canGoBack?: boolean;
  onBack?: () => void;
  children: React.ReactNode;
}

const OTFromScreen: React.FC<OTFromScreenProps> = ({
  canGoBack = false,
  onBack,
  children,
}) => {
  return (
    <div className="flex h-screen relative">
      <Logo />
      <BackgroundImage />
      <div className="flex flex-1 items-center justify-center p-sm4 bg-base-white">
        <div className="w-full max-w-md">
          <div className="flex flex-col gap-sm4">
            {canGoBack && (
              <Button
                Icon={ArrowLeftIcon}
                iconSize="sm"
                label="back"
                size="small"
                variant="SECONDARY"
                onClick={onBack}
              />
            )}
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTFromScreen;
